<template>
	<div class="table-listings px-3">
		<el-table ref="customerDocTable" :data="tableData" style="width: 100%"
			@selection-change="selectionChange"  :border="true" size="small"
			v-loading="is_loading"
			>
			<el-table-column type="selection"></el-table-column>
			<el-table-column label="FIle Name / Category" min-width="300">
				<template scope="scope">
					<div>
						<a href="javascript:void(0)" class="text-primary font-weight-bold"
							@click="$refs.preview_modal.preview(scope.row.url, scope.row.original_filename)">
							{{ scope.row.original_filename }}
						</a>
						<small>{{ scope.row.category ? scope.row.category.name : '-' }}</small>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="updated_at" label="Updated Date" width="110">
				<template scope="scope">
					<div>{{ scope.row.updated_at | dateTimeFormatString }}</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="text-right mt-3" v-if="is_editable">
			<el-button class="bg-primary text-white py-2" @click="update" :loading="is_loading">Update</el-button>
		</div>
		<PreviewModal ref="preview_modal"></PreviewModal>
	</div>
</template>
<script>
import { Table, TableColumn, Button } from 'element-ui'
import PreviewModal from '@/components/Modal/PreviewModal'
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useAttachmentStore } from '@/stores/attachmentStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
	props: ['proposal','is_editable'],
	mixins: [notifyFunctionMixin],
	components: {
		PreviewModal,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			is_loading: false,
			tableData: [],
			selectedRows: [],
			selectedAttcIds: [],
		}
	},
	created() {
		this.tableData = [];
	},
	watch: {
		proposal: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.getAllAttachments()
				}
			},
			immediate: true,
		}
	},
	methods: {
		...mapActions(useAttachmentStore, ['getAttachments']),
		...mapActions(useInitialProposalStore, ['updateProposal']),
		async getAllAttachments() {
			this.is_loading = true;
			this.tableData = [];
			if (!_gHlp.isEmpty(this.proposal.psal_customer_id)) {
				let params = {
					owner_id: this.proposal.psal_customer_id,
					owner_type: 'customer'
				}
				let attc = await this.getAttachments(params)
				for (let i = 0; i < attc.length; i++) {
					const el = attc[i];
					this.tableData.push(el)
				}
			}
			// if (!_gHlp.isEmpty(this.psal_id)) {
			// 	let papp_attc_ids = this.proposal.appendixes.flatMap(apdx => apdx.attachment_id)
			// 	let params = {
			// 		owner_id: this.psal_id,
			// 		owner_type: 'proposal'
			// 	}
			// 	this.getAttachments(params).then(resp => {
			// 		for (let i = 0; i < resp.length; i++) {
			// 			const el = resp[i];
			// 			if(papp_attc_ids.includes(el.attachment_id)){
			// 				this.tableData.push(el)
			// 			}
			// 		}
			// 	})
			// 		.catch(e => {
			// 			_gNotif.errorFunction(e)
			// 		})
			// }
			
			this.$refs.customerDocTable.clearSelection();
			let selectedAttc = (!_gHlp.isEmpty(this.proposal.psal_attc_ids_json)) ? this.proposal.psal_attc_ids_json : [];
			this.tableData.forEach(row => {
				if(selectedAttc.includes(row.attachment_id)){
					this.$refs.customerDocTable.toggleRowSelection(row);
				}
			});

			this.is_loading = false;
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
			this.selectedAttcIds = this.selectedRows.flatMap(row => row.attachment_id)
		},
		update(){
			this.updateProposal(this.proposal.psal_id,{psal_attc_ids_json:this.selectedAttcIds})
		}
	}
}
</script>